<template>
  <div>
    <b-row v-for="{date, changes} in activity" :key="date" class="timeline-item my-2">
      <b-col cols="1" class="col-score">
        <b-badge variant="info" pill v-b-tooltip.right="new Date(changes[0].created_at).toLocaleString()">{{new Date(changes[0].created_at).toLocaleString('en-us', {month: 'short', day: 'numeric'})}}</b-badge>
      </b-col>
      <b-col class="mt-2">
        <div v-for="change in changes" :key="change.field + change.created_at" class="text-small mb-1">
          <strong>{{change.description}}</strong>
          <template v-if="change.field == 'created_at' && change.new">
            <div v-for="(value, key) in change.new" :key="key">
              {{key|titleCase}}: 
              <span :class="key == 'title' ? 'page_title' : ''">{{value}}</span>
            </div>
          </template>
          <span v-else-if="change.new">: {{ change.new }}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.timeline-item {
  .col-score {
    position: relative;
    .badge {
      position: relative;
      z-index: 1;
      background: var(--indigo)
    }
  }
  &:not(:last-child) {
    .col-score::after {
      display: block;
      content: " ";
      position: relative;
      left: calc(50%);
      border-left: 1px dotted var(--indigo);
      height: 100%;
      width: 1px;
      top: -2px;
    }
  }
}
</style>
<script>
import PAGE_HISTORY_QUERY from '@/graphql/PageHistoryQuery.gql'
import {pick, get, startCase} from 'lodash'

export default {
  name: 'PageHistory',
  components: { },
  props: {
    page: Object,
  },
  data() {
    return {
      logs: [],
    }
  },
  apollo: {
    logs: {
      query: PAGE_HISTORY_QUERY,
      variables() {
        return {
          page_id: this.$route.params.page_id
        }
      },
    },
  },
  computed: {
    activity() {
      if(!this.page || !this.page.id) {
        return []
      }
      const actions = {
        optimized_title: 'Title Changed',
        link_score: 'Link Score Changed',
        perf_score: 'Perf Score Changed',
        status: 'Status Changed',
        status_code: 'Status Code Changed',
      }
      const days = {}
      const updatesOnCrawl = ['link_score', 'status_code', 'perf_score']

      this.logs.forEach(function(log) {
        const items = Object.keys(actions)
          // Status change can be NULL. Filter out the rest to hide initial crawl logs
          .filter(f => log.content.new[f] && (log.content.old[f] || !updatesOnCrawl.includes(f)) && log.content.old[f] != log.content.new[f])
          .map(field => ({
            field,
            created_at: log.created_at,
            description: actions[field],
            old: log.content.old[field],
            new: field == 'status' ? startCase(log.content.new[field].replace('completed','monitoring')) : log.content.new[field],
          }))
          if(items.length) {
            const date = log.created_at.substring(0, 10);
            days[date] = (days[date] || []).concat(items)
          }
      })

      const createdAt = this.page.created_at.substring(0, 10)
      let oldest = this.page
      if(this.logs.length) {
        oldest = {...oldest, ...get(this.logs.findLast(e => get(e, 'content.old.link_score') >= 0), 'content.old', {})}
      }
      days[createdAt] = (days[createdAt] || []).concat([{
        field: 'created_at',
        created_at: this.page.created_at,
        description: 'Page Discovered',
        new: pick(oldest, updatesOnCrawl.concat(['title', 'title_score']))
      }])
      
      let sorted = Object.entries(days)
      sorted.sort((a, b) => a[0] < b[0])
      return sorted.map(([date, changes]) => ({date, changes}))
    },
  },
}
</script>
